// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c9f313b1","403":"2bdc15da","551":"c2ddb01f","672":"477a6254","842":"01821987"}[chunkId] + ".chunk.js";
};